import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ShoppingService } from '../../core/services/shopping.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AddressModel, CountryModel, ErrorBody, UspsAddressModel } from '../../core/models/ShoppingCart.model';
import { appVariables, appMessages, appRoles } from '../../core/constants/Common.constant';
import { HelperService } from '../../core/services/helper.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PhysicalWebOrderComponent } from '../physical-web-order/physical-web-order.component';
import { ReturnStatement } from '../../../../node_modules/@angular/compiler';
import { stringify } from '@angular/core/src/util';
import { UspsDialogComponent } from '../usps-dialog/usps-dialog.component';
import { UspsService } from '../../core/services/usps.service';
import { AlertComponent } from '../../layout/prompt/alert.component';
import { CheckoutComponent } from '../checkout/checkout.component';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {
  CountryList: CountryModel[];
  StateList: CountryModel[];
  ShippingCountryList: CountryModel[];
  ShippingStateList: CountryModel[];
  addressForm: FormGroup;
  EnableShippingAddress: boolean;
  BillingAddress: AddressModel;
  ShowError: boolean;
  ErrorValue: string;
  ShowOtherCountryError = false;
  ShowOtherCountryStateText: boolean;
  ShowOtherCountryShippingStateText: boolean;
  ShowAPIErrormsg: boolean;
  APIErrorMsg: string;
  ErrorMsg: ErrorBody;
  // ShowBillingAddress: AddressModel;
  ShowViewAddressMode: boolean;
  IsPhysicalBookAdded = false;
  IncorrectAddressMsg1 = appMessages.IncorrectAddressMsg1;
  IncorrectAddressMsg2 = appMessages.IncorrectAddressMsg2;
  ItemsCount = 0;
  flagError = 0;
  ValidZipCodeLength: boolean;
  ValidShippingZipCodeLength: boolean;
  ZipCodeApiErrorMsg: string;
  PhoneNumApiErrorMsg: string;
  StreetNumApiErrorMsg: string;
  ShippingZipApiErrorMsg: string;
  ShippingPhoneApiErrorMsg: string;
  IsBSDiff: boolean;
  IsZipCorrect: boolean;
  IsPhoneCorrect: boolean;
  addressObject: UspsAddressModel;
  addressUspsObject: UspsAddressModel;

  chkPOAddressFormat: boolean;
  chkBillingPOBoxAddress: string;
  chkShippingPOBoxAddress: string;
  chkBillingPOBoxAditionalAddress: string;
  chkShippingPOBoxAditionalAddress: string;
  hyphenValidationErrorMessage: string = 'Please enter the address without hyphens';
  CheckCountLoop: number;
  IsUSorCanada: boolean=true;
  IsShippingUSorCanada: boolean=true;
  IsOtherBillingCountry : boolean =false;
  IsOtherShippingCountry : boolean =false;
  IsShippingZipCorrect : boolean=false;
  InvalidAddressArray : string[]=['po box','p o box','p.o. box','p. o. box','p o. box','p. o box','p.o box','po. box','p.o.box','post office box','postoffice box','post officebox','postofficebox'];//LMM-5181 changes
  CreditCardPhoneNumber: string = appMessages.CreditCardPhoneNumber
  IsUserLogged:boolean;

  constructor(private shoppingService: ShoppingService, private checkout:CheckoutComponent
    , private helperService: HelperService
    , public dialog: MatDialog
    , private uspsService: UspsService) {

      
    this.BillingAddress = new AddressModel();
  }


    // ngAfterViewInit() {
  //   setTimeout(() => {
  //     this.shoppingService.observeAddress.subscribe(address => {
  //       this.BillingAddress = address;

  //       this.CountryList = this.BillingAddress.BillingCountryList_ForAPI;
  //       if (this.BillingAddress.Country === appVariables.CountryCode.Canada) {
  //         this.StateList = this.BillingAddress.BillingCanadaStateList_ForAPI;
  //       } else if (this.BillingAddress.Country === appVariables.CountryCode.US) {
  //         this.StateList = this.BillingAddress.BillingUSAStateList_ForAPI;
  //       }
  //       this.ShippingCountryList = this.BillingAddress.BillingCountryList_ForAPI;
  //       if (this.BillingAddress.ShippingCountry === appVariables.CountryCode.Canada) {
  //         this.ShippingStateList = this.BillingAddress.ShippingCanadaStateList_ForAPI;
  //       } else if (this.BillingAddress.ShippingCountry === appVariables.CountryCode.US) {
  //         this.ShippingStateList = this.BillingAddress.ShippingUSAStateList_ForAPI;
  //       }
  //       setTimeout(() => { this.initForm(); }, 1000);
  //     });
  //   });
  // }

  ngOnInit() {
    this.checkout.observeIsUserLogged.subscribe(IsUserLogged => {
      this.IsUserLogged = IsUserLogged;
    });
    this.ValidZipCodeLength = false;
    this.ValidShippingZipCodeLength = false;
    this.ShowViewAddressMode = false;
    this.IsBSDiff = false;
    this.PhoneNumApiErrorMsg = '';
    this.ZipCodeApiErrorMsg = '';
    this.StreetNumApiErrorMsg = '';
    this.ShippingZipApiErrorMsg = '';
    this.ShippingPhoneApiErrorMsg = '';


    this.IsZipCorrect = true;
    this.IsShippingZipCorrect = true;
    this.IsPhoneCorrect = true;
    this.ShowAPIErrormsg = false;
    this.chkPOAddressFormat = false;

    const Token = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage);
    this.shoppingService.IsCheckoutComponent.emit(true);
    if (Token) {
      this.ShowViewAddressMode = this.helperService.getFromLocalStorage(appVariables.addressMode) === 'true' ? true : false;
      this.shoppingService.setAddressMode(this.ShowViewAddressMode);
      this.shoppingService.IsLoggedIn.emit(true);
    }

    this.shoppingService.observeAddressMode.subscribe(value => {
      this.ShowViewAddressMode = value;
    });
    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
      this.ItemsCount = cartItemsList.length;
      for (let i = 0; i < cartItemsList.length; i++) {
        if (cartItemsList[i].IsDigitalProduct !== true) {
          this.IsPhysicalBookAdded = true;
        }
      }
    });
    this.initForm();
    this.shoppingService.observeAddress.subscribe(address => {
      this.BillingAddress = address;
      this.CountryList = this.BillingAddress.BillingCountryList_ForAPI;
      if (this.BillingAddress.BillingCountryCode === appVariables.CountryCode.Canada) {
        this.StateList = this.BillingAddress.BillingCanadaStateList_ForAPI;
      } else if (this.BillingAddress.BillingCountryCode === appVariables.CountryCode.US) {
        this.StateList = this.BillingAddress.BillingUSAStateList_ForAPI;
      }
      this.ShippingCountryList = this.BillingAddress.BillingCountryList_ForAPI;
      if (this.BillingAddress.ShippingCountryCode === appVariables.CountryCode.Canada) {
        this.ShippingStateList = this.BillingAddress.ShippingCanadaStateList_ForAPI;
      } else if (this.BillingAddress.ShippingCountryCode === appVariables.CountryCode.US) {
        this.ShippingStateList = this.BillingAddress.ShippingUSAStateList_ForAPI;
      }
      // this.BillingAddress.Country =  appVariables.CountryCode.US;
      this.initForm();
      this.OnCheckClick(this.BillingAddress.BillingShippingDifferent);
    });
  }

  ValidateZipCode() {

    if (this.IsOtherBillingCountry) {
      this.SetShowOtherCountryError(false);//Added for FAD-1124
      this.ShowError = false;//Added for FAD-1124
      this.ZipCodeApiErrorMsg = '';
      this.ValidZipCodeLength = false;
      this.IsZipCorrect = true;
      return true;
    }


    if (this.addressForm.controls['BillingShippingDifferent'].value == false && this.IsBSDiff === false) {
      if (this.addressForm.controls['ZipCode'].value.length === 5 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.US) {
        this.ValidZipCodeLength = false;
        this.ZipCodeApiErrorMsg = '';
        this.IsZipCorrect = true;
        return true;
      }
      else if (this.addressForm.controls['ZipCode'].value.length === 7 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidZipCodeLength = false;
        this.ZipCodeApiErrorMsg = '';
        this.IsZipCorrect = true;
        return true;
      }
      else if (this.addressForm.controls['ZipCode'].value.length > 5 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.US) {
        this.ValidZipCodeLength = true;
        this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
        this.IsZipCorrect = true;
        return true;
      }
      else if (this.addressForm.controls['ZipCode'].value.length < 5 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.US) {
        this.ValidZipCodeLength = true;
        this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
        this.IsZipCorrect = true;
        return true;
      }
      else if (this.addressForm.controls['ZipCode'].value.length > 7 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidZipCodeLength = true;
        this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
        this.IsZipCorrect = true;
        return true;
      }
      else if (this.addressForm.controls['ZipCode'].value.length < 7 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidZipCodeLength = true;
        this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
        this.IsZipCorrect = true;
        return true;
      }
      else {
        this.IsUSorCanada = false;
        this.ValidZipCodeLength = false;
        this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
        this.IsZipCorrect = false;
        return false;

      }
    }
    else {
      this.ValidateZipCodeAll();
      return this.IsZipCorrect;
    }
  }

  ValidateZipCodeAll() {

    if (this.addressForm.controls['ZipCode'].value.length === 5 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.US) {
      this.ValidZipCodeLength = false;
      this.ZipCodeApiErrorMsg = '';
      if (this.addressForm.controls['ShippingZipCode'].value.length === 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length === 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        //this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        //  this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      this.IsZipCorrect = true;
      return true;
    }
    else if (this.addressForm.controls['ZipCode'].value.length === 7 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.Canada) {
      this.ValidZipCodeLength = false;
      this.ZipCodeApiErrorMsg = '';
      if (this.addressForm.controls['ShippingZipCode'].value.length === 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length === 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      this.IsZipCorrect = true;
      return true;
    }
    else if (this.addressForm.controls['ZipCode'].value.length > 5 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.US) {
      this.ValidZipCodeLength = true;
      this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
      if (this.addressForm.controls['ShippingZipCode'].value.length === 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length === 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        //this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      this.IsZipCorrect = true;
      return true;
    }
    else if (this.addressForm.controls['ZipCode'].value.length < 5 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.US) {
      this.ValidZipCodeLength = true;
      this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
      if (this.addressForm.controls['ShippingZipCode'].value.length === 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length === 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      this.IsZipCorrect = true;
      return true;
    }
    else if (this.addressForm.controls['ZipCode'].value.length > 7 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.Canada) {
      this.ValidZipCodeLength = true;
      this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
      if (this.addressForm.controls['ShippingZipCode'].value.length === 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length === 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      this.IsZipCorrect = true;
      return true;
    }
    else if (this.addressForm.controls['ZipCode'].value.length < 7 && this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.Canada) {
      this.ValidZipCodeLength = true;
      this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
      if (this.addressForm.controls['ShippingZipCode'].value.length === 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length === 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = false;
        this.ShippingZipApiErrorMsg = '';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 5 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length > 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      if (this.addressForm.controls['ShippingZipCode'].value.length < 7 && this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada) {
        // this.ValidShippingZipCodeLength = true;
        this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      }
      this.IsZipCorrect = true;
      return true;
    }
    else if (this.IsOtherBillingCountry) {
      this.CheckOtherCountyZipValidation();
    }

    else if (this.IsOtherShippingCountry) {
      this.CheckOtherCountyZipValidation();
    }
    else {
      this.IsUSorCanada = false;
      this.ValidZipCodeLength = false;
      this.ValidShippingZipCodeLength = false;
      this.ZipCodeApiErrorMsg = 'Enter proper zip-code.';
      this.ShippingZipApiErrorMsg = 'Enter proper zip-code.';
      // this.IsShippingZipCorrect = false;
      this.IsZipCorrect = true;
      return false;

    }
  }
  CheckOtherCountyZipValidation() {
    this.ValidZipCodeLength = false;
    this.ValidShippingZipCodeLength = false;
    this.ZipCodeApiErrorMsg = '';
    this.ShippingZipApiErrorMsg = '';
    //this.IsShippingZipCorrect = true;
    this.IsZipCorrect = true;
    return true;
  }

  ValidatePhoneNo() {
    if (this.addressForm.controls['BillingShippingDifferent'].value == false && this.IsBSDiff === false) {
      if (this.addressForm.controls['Phone'].value.replace(/[^0-9]/g, "").length === 10) {
        this.PhoneNumApiErrorMsg = '';
        return true;
      }
      else {
        this.PhoneNumApiErrorMsg = 'Phone is invalid.';
        return false;
      }
    }
    else {
      if (this.addressForm.controls['Phone'].value.replace(/[^0-9]/g, "").length === 10) {
        this.PhoneNumApiErrorMsg = '';
        if (this.addressForm.controls['ShippingPhone'].value.replace(/[^0-9]/g, "").length === 10) {
          this.ShippingPhoneApiErrorMsg = '';
          return true;
        }
        else {
          this.ShippingPhoneApiErrorMsg = 'Phone is invalid.';
          return false;
        }
      }
      else {
        if (this.addressForm.controls['ShippingPhone'].value.replace(/[^0-9]/g, "").length === 10) {
          this.ShippingPhoneApiErrorMsg = '';
          return true;
        }
        else {
          this.ShippingPhoneApiErrorMsg = 'Phone is invalid.';
          return false;
        }
      }

    }
  }

  ValidatePOBox(addressFieldType: string) {
    if (addressFieldType == 'shippingAddress')
      this.chkBillingPOBoxAddress = '';
    if (addressFieldType == 'additionalAddress')
      this.chkShippingPOBoxAddress = '';
    if (addressFieldType == 'ShippingStreetAddress')
      this.chkBillingPOBoxAditionalAddress = '';
    if (addressFieldType == 'ShippingAdditionalAddress')
      this.chkShippingPOBoxAditionalAddress = '';
    this.CheckCountLoop = 0;

    if (this.addressForm.controls['BillingShippingDifferent'].value == false && this.IsBSDiff === false) {
      if (!this.addressForm.controls['StreetAddress'].value !== null || this.addressForm.controls['StreetAddress'].value !== "") {
        if(addressFieldType == 'shippingAddress'){
          var streetAddress=this.addressForm.controls['StreetAddress'].value.toLowerCase();
        if (this.InvalidAddressArray.some(x=> streetAddress.indexOf(x)>=0)) {
          this.chkBillingPOBoxAddress = '';
          this.ShowError = true;
          this.chkShippingPOBoxAddress = '';
          this.CheckCountLoop = this.CheckCountLoop + 1;
        }
        else {
            this.chkBillingPOBoxAddress = '';
          }
        }  
        if(addressFieldType == 'additionalAddress'){
          var additionalAddress=this.addressForm.controls['AdditionalAddress'].value;
        if ((additionalAddress !== null) && (this.InvalidAddressArray.some(x=> additionalAddress.toLowerCase().indexOf(x)>=0))) {
          this.chkBillingPOBoxAditionalAddress = 'Sorry, we cannot ship to a P.O. Box. Please enter another valid address.';
          this.CheckCountLoop = this.CheckCountLoop + 1;
        }
        else {
            this.chkBillingPOBoxAditionalAddress = '';
          }
        }
        if (this.CheckCountLoop === 0) {
          return false;
        }
        else {
          return true;
        }

      }
      else {
        return false;
      }
    }
    else {
      if (this.addressForm.controls['StreetAddress'].value !== null || this.addressForm.controls['StreetAddress'].value !== "" ||
        this.addressForm.controls['ShippingStreetAddress'].value === null || this.addressForm.controls['ShippingStreetAddress'].value === "") {
        
        if(addressFieldType == 'ShippingStreetAddress'){
          var shippingStreetAddress=this.addressForm.controls['ShippingStreetAddress'].value;
          if ((shippingStreetAddress !== null) && (this.InvalidAddressArray.some(x=> shippingStreetAddress.toLowerCase().indexOf(x)>=0))) {
          this.chkShippingPOBoxAddress = 'Sorry, we cannot ship to a P.O. Box. Please enter another valid address.';
          this.CheckCountLoop = this.CheckCountLoop + 1;
        }
        else {
            this.chkShippingPOBoxAddress = '';
          }
        }
        if(addressFieldType == 'additionalAddress'){
          var additionalAddress=this.addressForm.controls['AdditionalAddress'].value;
          if ((additionalAddress !== null) && (this.InvalidAddressArray.some(x=> additionalAddress.toLowerCase().indexOf(x)>=0))) {
            this.chkBillingPOBoxAditionalAddress = 'Sorry, we cannot ship to a P.O. Box. Please enter another valid address.';
            this.CheckCountLoop = this.CheckCountLoop + 1;
        }
        else {
            this.chkBillingPOBoxAditionalAddress = '';
          }
        }
        if(addressFieldType == 'ShippingAdditionalAddress'){
          var shippingAddionalAddress=this.addressForm.controls['ShippingAdditionalAddress'].value;
          if ((shippingAddionalAddress !== null) && (this.InvalidAddressArray.some(x=> shippingAddionalAddress.toLowerCase().indexOf(x)>=0))) {
          this.chkShippingPOBoxAditionalAddress = 'Sorry, we cannot ship to a P.O. Box. Please enter another valid address.';
          this.CheckCountLoop = this.CheckCountLoop + 1;
        }
        else {
            this.chkShippingPOBoxAditionalAddress = '';
          }
        }
        if (this.CheckCountLoop === 0) {
          return false;
        }
        else {
          return true;
        }
      }
      else {
        if (addressFieldType == 'shippingAddress')
          this.chkBillingPOBoxAddress = '';
        if (addressFieldType == 'ShippingStreetAddress')
          this.chkShippingPOBoxAddress = '';
        if (addressFieldType == 'additionalAddress')
          this.chkBillingPOBoxAditionalAddress = '';
        if (addressFieldType == 'ShippingAdditionalAddress')
          this.chkShippingPOBoxAditionalAddress = '';
        return false;
      }
    }
  }

  OnSaveAddressClick() {
    this.chkBillingPOBoxAddress = '';
    this.chkShippingPOBoxAddress = '';
    this.chkShippingPOBoxAditionalAddress = '';
    this.chkShippingPOBoxAditionalAddress = '';

    this.PhoneNumApiErrorMsg = '';
    this.ZipCodeApiErrorMsg = '';
    this.StreetNumApiErrorMsg = '';
    this.ShippingZipApiErrorMsg = '';
    this.ShippingPhoneApiErrorMsg = '';
    this.CheckHyphenValidation(this.addressForm.controls.StreetAddress.value, 'shippingAddress');
    this.CheckHyphenValidation(this.addressForm.controls.AdditionalAddress.value, 'additionalAddress');
    this.ValidationCheckforShippingAddress(false);

    if (this.addressForm.controls.BillingShippingDifferent.value === true) {
      this.CheckHyphenValidation(this.addressForm.controls.ShippingStreetAddress.value, 'ShippingStreetAddress');
      this.CheckHyphenValidation(this.addressForm.controls.ShippingAdditionalAddress.value, 'ShippingAdditionalAddress');
      if (!this.ShowError) {
        this.ValidationCheckforShippingAddress(true);
      }
    }
    else {
      this.addressForm.controls['ShippingFirstName'].setValue(null);
      this.addressForm.controls['ShippingLastName'].setValue(null);
      this.addressForm.controls['SelectedShippingCountry'].setValue(null);
      this.addressForm.controls['ShippingStreetAddress'].setValue(null);
      this.addressForm.controls['ShippingCity'].setValue(null);
      this.addressForm.controls['SelectedShippingState'].setValue(null);
      this.addressForm.controls['ShippingZipCode'].setValue(null);
      this.addressForm.controls['ShippingPhone'].setValue(null);
      this.addressForm.controls['ShippingFirstName'].updateValueAndValidity();
      this.addressForm.controls['ShippingLastName'].updateValueAndValidity();
      this.addressForm.controls['SelectedShippingCountry'].updateValueAndValidity();
      this.addressForm.controls['ShippingStreetAddress'].updateValueAndValidity();
      this.addressForm.controls['ShippingCity'].updateValueAndValidity();
      this.addressForm.controls['SelectedShippingState'].updateValueAndValidity();
      this.addressForm.controls['ShippingZipCode'].updateValueAndValidity();
      this.addressForm.controls['ShippingPhone'].updateValueAndValidity();

    }

    if (this.ShowError) {
      return false;
    }

    if ((!this.IsUSorCanada || this.IsZipCorrect) && this.IsPhoneCorrect && !this.chkPOAddressFormat) {
      this.BillingAddress.Country = this.BillingAddress.BillingCountryList_ForAPI
        .find(country => country.Value && this.addressForm.controls['SelectedCountry'] &&
          country.Value.toUpperCase() === this.addressForm.controls['SelectedCountry'].value.toUpperCase()).Text;
      if (this.addressForm.controls.BillingShippingDifferent.value === true) {
        this.BillingAddress.ShippingCountry = this.BillingAddress.BillingCountryList_ForAPI
          .find(country => country.Value && this.addressForm.controls['SelectedShippingCountry'].value &&
            country.Value.toUpperCase() === this.addressForm.controls['SelectedShippingCountry'].value.toUpperCase()).Text;
      }
      this.shoppingService.observeCartItems.subscribe(cartItemsList => {
        this.ItemsCount = cartItemsList.length;
        for (let i = 0; i < cartItemsList.length; i++) {
          if (cartItemsList[i].IsDigitalProduct !== true) {
            this.IsPhysicalBookAdded = true;
          }
        }
      });
      if (this.IsPhysicalBookAdded === true) {
        if (this.addressForm.controls.BillingShippingDifferent.value === false) {
          if (this.addressForm.controls['SelectedCountry'].value !== appVariables.CountryCode.US) {

            this.shoppingService.SaveAddressDetailsFromAPI(this.addressForm.value)
              .subscribe(
                (response) => {
                  this.OnContinuetoPaymentClick();
                },
                (error) => {
                  this.ShowAPIErrormsg = true;
                  this.ErrorMsg = JSON.parse(error._body);
                  if (this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError && !this.IsUserLogged) {
                    this.ShowError = true;
                    let dialogRef = this.dialog.open(AlertComponent, {
                      disableClose: true,
                      hasBackdrop: true, // or false, depending on what you want
                    });
                    return;
                  }
                  else if(this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError){
                    this.ShowAPIErrormsg = false;
                    this.shoppingService.setAddressMode(true);
                    this.helperService.setToLocalStorage(appVariables.addressMode, 'true');
                    this.shoppingService.setDisplaySection('Address');
                    this.shoppingService.GetPaymentDetails();
                    this.shoppingService.loadItems();
                  }
                  else {
                    this.APIErrorMsg = this.ErrorMsg.Error;
                  }

                  for (let i = 0; i <= this.APIErrorMsg.length; i++) {
                    if (this.APIErrorMsg[i] === 'Enter proper zip-code.') {
                      this.ZipCodeApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.APIErrorMsg[i] === 'Enter proper phone.') {
                      this.PhoneNumApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.APIErrorMsg[i] === 'Missing Required Field: StreetNumber') {
                      this.StreetNumApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.APIErrorMsg[i] === 'Shipping Enter proper zip-code.') {
                      this.ShippingZipApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.APIErrorMsg[i] === 'Enter proper shipping phone.') {
                      this.ShippingPhoneApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.ZipCodeApiErrorMsg !== '' || this.PhoneNumApiErrorMsg !== '' || this.StreetNumApiErrorMsg !== '' ||
                      this.ShippingZipApiErrorMsg !== '' || this.ShippingPhoneApiErrorMsg !== '') {
                      this.APIErrorMsg = '';
                    }
                  }

                }
              );
          } else {//LMM-3870 changes
            this.shoppingService.SaveAddressDetailsFromAPI(this.addressForm.value)
              .subscribe(
                (response) => {
                  this.shoppingService.setAddressMode(true);
                  this.helperService.setToLocalStorage(appVariables.addressMode, 'true');
                  this.shoppingService.setDisplaySection('Address');
                  this.shoppingService.GetPaymentDetails();
                  this.shoppingService.loadItems();
                },
                (error) => {
                  this.ShowAPIErrormsg = true;
                  this.ErrorMsg = JSON.parse(error._body);
                  if (this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError && !this.IsUserLogged) {
                    this.ShowError = true;
                    let dialogRef = this.dialog.open(AlertComponent, {
                      disableClose: true,
                      hasBackdrop: true, // or false, depending on what you want
                    });
                    return;
                  }
                  else if(this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError){
                    this.ShowAPIErrormsg = false;
                    this.shoppingService.setAddressMode(true);
                    this.helperService.setToLocalStorage(appVariables.addressMode, 'true');
                    this.shoppingService.setDisplaySection('Address');
                    this.shoppingService.GetPaymentDetails();
                    this.shoppingService.loadItems();
                  }
                  else {
                    this.APIErrorMsg = this.ErrorMsg.Error;
                  }

                  for (let i = 0; i <= this.APIErrorMsg.length; i++) {
                    if (this.APIErrorMsg[i] === 'Enter proper zip-code.') {
                      this.ZipCodeApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.APIErrorMsg[i] === 'Enter proper phone.') {
                      this.PhoneNumApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.APIErrorMsg[i] === 'Missing Required Field: StreetNumber') {
                      this.StreetNumApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.APIErrorMsg[i] === 'Shipping Enter proper zip-code.') {
                      this.ShippingZipApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.APIErrorMsg[i] === 'Enter proper shipping phone.') {
                      this.ShippingPhoneApiErrorMsg = this.APIErrorMsg[i];
                    }
                    if (this.ZipCodeApiErrorMsg !== '' || this.PhoneNumApiErrorMsg !== '' || this.StreetNumApiErrorMsg !== '' ||
                      this.ShippingZipApiErrorMsg !== '' || this.ShippingPhoneApiErrorMsg !== '') {
                      this.APIErrorMsg = '';
                    }
                  }
                }
              );
          }
        } else if (this.addressForm.controls['SelectedShippingCountry'].value !== appVariables.CountryCode.US) {
          this.shoppingService.SaveAddressDetailsFromAPI(this.addressForm.value)
            .subscribe(
              (response) => {
                this.OnContinuetoPaymentClick();
              },
              (error) => {
                this.ShowAPIErrormsg = true;
                this.ErrorMsg = JSON.parse(error._body);
                if (this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError && !this.IsUserLogged) {
                  this.ShowError = true;
                  let dialogRef = this.dialog.open(AlertComponent, {
                    disableClose: true,
                    hasBackdrop: true, // or false, depending on what you want
                  });
                  return;
                }
                else if(this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError){
                  this.ShowAPIErrormsg = false;
                  this.shoppingService.setAddressMode(true);
                  this.helperService.setToLocalStorage(appVariables.addressMode, 'true');
                  this.shoppingService.setDisplaySection('Address');
                  this.shoppingService.GetPaymentDetails();
                  this.shoppingService.loadItems();
                }
                else {
                  this.APIErrorMsg = this.ErrorMsg.Error;
                }

                for (let i = 0; i <= this.APIErrorMsg.length; i++) {
                  if (this.APIErrorMsg[i] === 'Enter proper zip-code.') {
                    this.ZipCodeApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.APIErrorMsg[i] === 'Enter proper phone.') {
                    this.PhoneNumApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.APIErrorMsg[i] === 'Missing Required Field: StreetNumber') {
                    this.StreetNumApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.APIErrorMsg[i] === 'Shipping Enter proper zip-code.') {
                    this.ShippingZipApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.APIErrorMsg[i] === 'Enter proper shipping phone.') {
                    this.ShippingPhoneApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.ZipCodeApiErrorMsg !== "" || this.PhoneNumApiErrorMsg !== "" || this.StreetNumApiErrorMsg !== "" ||
                    this.ShippingZipApiErrorMsg !== "" || this.ShippingPhoneApiErrorMsg !== "") {
                    this.APIErrorMsg = "";
                  }
                }

              }
            );
        } else {//LMM-3870 changes
          this.shoppingService.SaveAddressDetailsFromAPI(this.addressForm.value)
            .subscribe(
              (response) => {
                this.shoppingService.setAddressMode(true);
                this.helperService.setToLocalStorage(appVariables.addressMode, 'true');
                this.shoppingService.setDisplaySection('Address');
                this.shoppingService.GetPaymentDetails();
                this.shoppingService.loadItems();
              },
              (error) => {
                this.ShowAPIErrormsg = true;
                this.ErrorMsg = JSON.parse(error._body);
                if (this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError && !this.IsUserLogged) {
                  this.ShowError = true;
                  let dialogRef = this.dialog.open(AlertComponent, {
                    disableClose: true,
                    hasBackdrop: true, // or false, depending on what you want
                  });
                  return;
                }
                else if(this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError){
                  this.ShowAPIErrormsg = false;
                  this.shoppingService.setAddressMode(true);
                  this.helperService.setToLocalStorage(appVariables.addressMode, 'true');
                  this.shoppingService.setDisplaySection('Address');
                  this.shoppingService.GetPaymentDetails();
                  this.shoppingService.loadItems();
                }
                else {
                  this.APIErrorMsg = this.ErrorMsg.Error;
                }

                for (let i = 0; i <= this.APIErrorMsg.length; i++) {
                  if (this.APIErrorMsg[i] === 'Enter proper zip-code.') {
                    this.ZipCodeApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.APIErrorMsg[i] === 'Enter proper phone.') {
                    this.PhoneNumApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.APIErrorMsg[i] === 'Missing Required Field: StreetNumber') {
                    this.StreetNumApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.APIErrorMsg[i] === 'Shipping Enter proper zip-code.') {
                    this.ShippingZipApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.APIErrorMsg[i] === 'Enter proper shipping phone.') {
                    this.ShippingPhoneApiErrorMsg = this.APIErrorMsg[i];
                  }
                  if (this.ZipCodeApiErrorMsg !== '' || this.PhoneNumApiErrorMsg !== '' || this.StreetNumApiErrorMsg !== '' ||
                    this.ShippingZipApiErrorMsg !== '' || this.ShippingPhoneApiErrorMsg !== '') {
                    this.APIErrorMsg = '';
                  }
                }
              }
            );
        }
      } else {
        this.shoppingService.SaveAddressDetailsFromAPI(this.addressForm.value)
          .subscribe(
            (response) => {
              this.shoppingService.setAddressMode(true);
              this.helperService.setToLocalStorage(appVariables.addressMode, 'true');
              this.shoppingService.setDisplaySection('Address');
              this.shoppingService.GetPaymentDetails();
              this.shoppingService.loadItems();
            },
            (error) => {
              this.ShowAPIErrormsg = true;
              this.ErrorMsg = JSON.parse(error._body);
              if (this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError && !this.IsUserLogged) {
                this.ShowError = true;
                let dialogRef = this.dialog.open(AlertComponent, {
                  disableClose: true,
                  hasBackdrop: true, // or false, depending on what you want
                });
                return;
              }
              else if(this.ErrorMsg.Error[0] == appMessages.AlreadyHaveAccessError){
                this.ShowAPIErrormsg = false;
                this.shoppingService.setAddressMode(true);
                this.helperService.setToLocalStorage(appVariables.addressMode, 'true');
                this.shoppingService.setDisplaySection('Address');
                this.shoppingService.GetPaymentDetails();
                this.shoppingService.loadItems();
              }
              else {
                this.APIErrorMsg = this.ErrorMsg.Error;
              }

              for (let i = 0; i <= this.APIErrorMsg.length; i++) {
                if (this.APIErrorMsg[i] == 'Enter proper zip-code.') {
                  this.ZipCodeApiErrorMsg = this.APIErrorMsg[i];
                }
                if (this.APIErrorMsg[i] == 'Enter proper phone.') {
                  this.PhoneNumApiErrorMsg = this.APIErrorMsg[i];
                }
                if (this.APIErrorMsg[i] == 'Missing Required Field: StreetNumber') {
                  this.StreetNumApiErrorMsg = this.APIErrorMsg[i];
                }
                if (this.APIErrorMsg[i] == 'Shipping Enter proper zip-code.') {
                  this.ShippingZipApiErrorMsg = this.APIErrorMsg[i];
                }
                if (this.APIErrorMsg[i] == 'Enter proper shipping phone.') {
                  this.ShippingPhoneApiErrorMsg = this.APIErrorMsg[i];
                }
                if (this.ZipCodeApiErrorMsg !== "" || this.PhoneNumApiErrorMsg !== "" || this.StreetNumApiErrorMsg !== "" ||
                  this.ShippingZipApiErrorMsg !== "" || this.ShippingPhoneApiErrorMsg !== "") {
                  this.APIErrorMsg = "";
                }
              }

            }
          );

      }

    }

  }

  OnContinuetoPaymentClick() {
    this.OnOpenPhysicalWebOrderReconcileDialog();
  }

  OnOpenPhysicalWebOrderReconcileDialog() {
    this.BillingAddress.Country = this.addressForm.controls['SelectedCountry'].value;
    this.BillingAddress.ShippingCountry = this.addressForm.controls['SelectedShippingCountry'].value;

    let dialogRef = this.dialog.open(PhysicalWebOrderComponent, {
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      panelClass: 'weborder',
      //  data: [BillingCountryName,ShippingCountryName]
      data: {
        BillingCountryName: this.BillingAddress.Country,
        ShippingCountryName: this.BillingAddress.ShippingCountry,
        BillingShippingDifferent: this.addressForm.controls.BillingShippingDifferent.value
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.IsPhysicalBookAdded = false;
    });
  }

  OnCheckClick(Checkevent) {
    Checkevent = Checkevent.target ? Checkevent.target.checked : Checkevent;
    this.IsBSDiff = Checkevent;
    this.addressForm.controls['BillingShippingDifferent'].setValue(Checkevent);
    this.ValiadteOtherFields(Checkevent);
    if (Checkevent) {
      // this.BillingAddress.SelectedShippingCountry = this.ShippingCountryList.
      //   find(country => country.Value.toUpperCase() === appVariables.CountryCode.US);
      if (!this.addressForm.controls['SelectedShippingCountry'].value) {
        this.addressForm.controls['SelectedShippingCountry'].setValue(appVariables.CountryCode.US);
        this.addressForm.controls['SelectedShippingState'].setValue(appVariables.DefaultState.ALABAMA);
      }
      this.SetShowError(false);
      this.ShowOtherCountryShippingStateText = false;
      this.addressForm.controls['ShippingFirstName'].setValidators([Validators.required]);
      this.addressForm.controls['ShippingLastName'].setValidators([Validators.required]);
      this.addressForm.controls['SelectedShippingCountry'].setValidators([Validators.required]);
      this.addressForm.controls['ShippingStreetAddress'].setValidators([Validators.required]);
      this.addressForm.controls['ShippingCity'].setValidators([Validators.required]);
      this.addressForm.controls['SelectedShippingState'].setValidators([Validators.required]);
      if (this.ShowOtherCountryShippingStateText === false) {
        this.addressForm.controls['ShippingZipCode'].setValidators([Validators.required, Validators.maxLength(5), Validators.minLength(5),
        Validators.pattern(appVariables.Regex_ZipPattern)]);
      } else {
        this.addressForm.controls['ShippingZipCode'].setValidators([Validators.required]);
      }
      this.addressForm.controls['ShippingPhone'].setValidators([Validators.required,
      Validators.pattern(appVariables.RegexPhonePattern)]);
      // this.addressForm.controls['ShippingExt'].setValidators([
      //   Validators.pattern(appVariables.Regex_ZipPattern), Validators.maxLength(3)]);
    } else {
      this.addressForm.controls['ShippingFirstName'].setValidators([]);
      this.addressForm.controls['ShippingLastName'].setValidators([]);
      this.addressForm.controls['SelectedShippingCountry'].setValidators([]);
      this.addressForm.controls['ShippingStreetAddress'].setValidators([]);
      this.addressForm.controls['ShippingCity'].setValidators([]);
      this.addressForm.controls['SelectedShippingState'].setValidators([]);
      this.addressForm.controls['ShippingZipCode'].setValidators([]);
      this.addressForm.controls['ShippingPhone'].setValidators([]);
      // this.addressForm.controls['ShippingExt'].setValidators([]);
    }
    this.addressForm.controls['ShippingFirstName'].updateValueAndValidity();
    this.addressForm.controls['ShippingLastName'].updateValueAndValidity();
    this.addressForm.controls['SelectedShippingCountry'].updateValueAndValidity();
    this.addressForm.controls['ShippingStreetAddress'].updateValueAndValidity();
    this.addressForm.controls['ShippingCity'].updateValueAndValidity();
    this.addressForm.controls['SelectedShippingState'].updateValueAndValidity();
    this.addressForm.controls['ShippingZipCode'].updateValueAndValidity();
    this.addressForm.controls['ShippingPhone'].updateValueAndValidity();
    // this.addressForm.controls['ShippingExt'].updateValueAndValidity();
    this.SetShowOtherCountryError(false);
    this.SetShowError(false);
    if (Checkevent === true) {
      const shippingCountryValue = this.addressForm.controls['SelectedShippingCountry'].value;
      if (shippingCountryValue) {
        this.ShippingContryChange(shippingCountryValue);
      }
    } else {
      const CountryValue = this.addressForm.controls['SelectedCountry'].value;
      if (CountryValue) {
        this.ContryChange(CountryValue, Checkevent);
      }
    }
  }

  SetShowError(value) {
    // this.ShowError = value;
    // if (value === true && this.IsPhysicalBookAdded === false) {
    //   this.ShowError = false;
    // }
  }
  SetShowOtherCountryError(value) {
    this.ShowOtherCountryError = value;
    if (value === true && this.IsPhysicalBookAdded === false) {
      this.ShowOtherCountryError = false;
    }
  }

  handleStateSelection(country: string, stateList: any[]) {
    if (!this.BillingAddress.State) {
      this.addressForm.controls['SelectedState'].setValue('');
      this.addressForm.controls['State'].setValue('');
    } else {
      this.addressForm.controls['State'].setValue('');
      if (this.addressForm.controls['SelectedState'].value != '') {
        let tempData = stateList.find(x => x.Value == this.addressForm.controls['SelectedState'].value);
        this.addressForm.controls['SelectedState'].setValue(this.BillingAddress.State);
        if (tempData == null) {
          this.addressForm.controls['SelectedState'].setValue('');
        }
      }
    }
  }

  handleShippingStateSelection(country: string, shippingStateList: any[]) {
    if (!this.BillingAddress.ShippingState) {
      this.addressForm.controls['SelectedShippingState'].setValue('');
      this.addressForm.controls['ShippingState'].setValue('');
    } else {
      this.addressForm.controls['ShippingState'].setValue('');
      if (this.addressForm.controls['SelectedShippingState'].value != '') {
        let tempData = shippingStateList.find(x => x.Value == this.addressForm.controls['SelectedShippingState'].value);
        this.addressForm.controls['SelectedShippingState'].setValue(this.BillingAddress.ShippingState);
        if (tempData == null) {
          this.addressForm.controls['SelectedShippingState'].setValue('');
        }
      }
    }
  }

  ContryChange(countryInput: string, ISBillingShippingDifferent: boolean) {
    if (countryInput === appVariables.CountryCode.Canada) {
      this.IsOtherBillingCountry = false;
      this.IsUSorCanada = true;
      this.StateList = this.BillingAddress.BillingCanadaStateList_ForAPI;

      this.handleStateSelection('Canada', this.BillingAddress.BillingCanadaStateList_ForAPI);

      // this.BillingAddress.SelectedState = this.BillingAddress.BillingCanadaStateList_ForAPI
      //   .find(country => country.Value && this.BillingAddress.State &&
      //     country.Value.toUpperCase() === this.BillingAddress.State.toUpperCase());

      // this.SetShowError(true);
      //this.ShowError = this.IsPhysicalBookAdded === false ? false : true;
      this.SetShowError(false);     //As per New Requirment 1264
      this.SetShowOtherCountryError(false);
      this.ShowOtherCountryStateText = false;
      this.addressForm.controls['SelectedState'].setValidators([]);
      this.addressForm.controls['State'].setValidators([]);
    } else if (countryInput === appVariables.CountryCode.US) {
      this.IsOtherBillingCountry = false;
      this.IsUSorCanada = true;
      this.SetShowError(false);
      this.ShowOtherCountryStateText = false;
      this.addressForm.controls['SelectedState'].setValidators([]);
      this.addressForm.controls['State'].setValidators([]);
      this.SetShowOtherCountryError(false);
      this.StateList = this.BillingAddress.BillingUSAStateList_ForAPI;

     this.handleStateSelection('US', this.BillingAddress.BillingUSAStateList_ForAPI);
      // this.BillingAddress.SelectedState = this.BillingAddress.BillingUSAStateList_ForAPI
      //   .find(country => country.Value &&
      //     this.BillingAddress.State && country.Value.toUpperCase() === this.BillingAddress.State.toUpperCase());
    } else if (countryInput !== appVariables.CountryCode.Canada && countryInput !== appVariables.CountryCode.US) {
      this.IsOtherBillingCountry = true;
      this.SetShowError(false);
      this.SetShowOtherCountryError(false); //Added for FAD-1124
      //  this.SetShowOtherCountryError(true); //new requirment 1264
      // this.ShowOtherCountryStateText = true;  //new requirment 1264
      //   this.ShowError = this.IsPhysicalBookAdded === false ? false : true;
      //this.SetShowOtherCountryError(true);
      this.ShowOtherCountryStateText = true;

      if (!this.BillingAddress.State) {
        this.addressForm.controls['State'].setValue('');
        this.addressForm.controls['SelectedState'].setValue('');
      } else {
        if(this.addressForm.controls['State'].value!=''){
        this.addressForm.controls['State'].setValue(this.BillingAddress.State);
        }
        this.addressForm.controls['SelectedState'].setValue('');     
      }

      this.addressForm.controls['SelectedState'].setValidators([]);
      this.addressForm.controls['State'].setValidators([]);
      this.IsUSorCanada = false;
      this.ShowError = false;
    } else {
      //this.SetShowOtherCountryError(true); //commented for FAD-1124
      this.SetShowError(false);
      this.IsUSorCanada = false;
    }
    this.addressForm.controls['SelectedState'].updateValueAndValidity();
    this.addressForm.controls['State'].updateValueAndValidity();
    if (this.ShowOtherCountryStateText === true) {
      this.addressForm.controls['ZipCode'].setValidators([]);
    } else {
      if (countryInput === appVariables.CountryCode.Canada) {
        this.addressForm.controls['ZipCode'].setValidators([Validators.maxLength(7), Validators.minLength(7),
        Validators.pattern(appVariables.Regex_ZipCodePattern_For_Canada)]);
      } else if (countryInput === appVariables.CountryCode.US) {
        this.addressForm.controls['ZipCode'].setValidators([Validators.maxLength(5), Validators.minLength(5),
        Validators.pattern(appVariables.Regex_ZipPattern)]);
      } else { // if (countryInput === appVariables.CountryCode.US)
        this.addressForm.controls['ZipCode'].setValidators([]);
      }
    }
    this.addressForm.controls['ZipCode'].updateValueAndValidity();
    if (ISBillingShippingDifferent === true) {
      this.SetShowOtherCountryError(false);
      this.SetShowError(false);
    }

    // if (!this.addressForm.controls['SelectedState'].value) {
    //  // this.BillingAddress.ShippingState = appVariables.DefaultState.ALBERTA;
    //   if (countryInput === appVariables.CountryCode.Canada) {
    //     this.addressForm.controls['SelectedState'].setValue(  this.BillingAddress.BillingCanadaStateList_ForAPI
    //       .find(country => country.Value &&
    //         country.Value.toUpperCase() === appVariables.DefaultState.ALBERTA.toUpperCase()));
    //   } else if (countryInput === appVariables.CountryCode.US) {
    //     this.addressForm.controls['SelectedState'].setValue(  this.BillingAddress.BillingUSAStateList_ForAPI
    //       .find(country => country.Value &&
    //         country.Value.toUpperCase() === appVariables.DefaultState.ALABAMA.toUpperCase()));
    //   }
    // }

  }

  ShippingContryChange(countryInput: string) {
    if (countryInput === appVariables.CountryCode.Canada) {
      this.IsOtherShippingCountry = false;
      this.IsShippingUSorCanada = true;
      this.ShippingStateList = this.BillingAddress.ShippingCanadaStateList_ForAPI;
      this.handleShippingStateSelection('Canada', this.BillingAddress.ShippingCanadaStateList_ForAPI);
      // if (this.BillingAddress.ShippingState) {
      //   this.BillingAddress.SelectedShippingState = this.BillingAddress.ShippingUSAStateList_ForAPI
      //     .find(country => country.Value && this.BillingAddress.ShippingState &&
      //       country.Value.toUpperCase() === this.BillingAddress.ShippingState.toUpperCase());
      // }

      //this.SetShowError(true);
      this.SetShowError(false);
      this.SetShowOtherCountryError(false);
      this.ShowOtherCountryShippingStateText = false;
      this.addressForm.controls['SelectedShippingState'].setValidators([]);
      this.addressForm.controls['ShippingState'].setValidators([]);
    } else if (countryInput === appVariables.CountryCode.US) {
      this.IsOtherShippingCountry = false;
      this.IsShippingUSorCanada = true;
      this.SetShowError(false);
      this.ShowOtherCountryShippingStateText = false;
      this.addressForm.controls['SelectedShippingState'].setValidators([]);
      this.addressForm.controls['ShippingState'].setValidators([]);
      this.SetShowOtherCountryError(false);
      this.ShippingStateList = this.BillingAddress.ShippingUSAStateList_ForAPI;
      this.handleShippingStateSelection('US', this.BillingAddress.ShippingUSAStateList_ForAPI);
      // if (this.BillingAddress.ShippingState) {
      //   this.BillingAddress.SelectedShippingState = this.BillingAddress.ShippingUSAStateList_ForAPI
      //     .find(country => country.Value && this.BillingAddress.ShippingState &&
      //       country.Value.toUpperCase() === this.BillingAddress.ShippingState.toUpperCase());
      // }
    } else if (
      countryInput !== appVariables.CountryCode.Canada && countryInput !== appVariables.CountryCode.US) {
      this.IsShippingUSorCanada = false;
      this.SetShowError(false);
      this.IsOtherShippingCountry = true;
      this.SetShowOtherCountryError(false);
      this.ShowOtherCountryShippingStateText = true;
      if (!this.BillingAddress.ShippingState) {
        this.addressForm.controls['ShippingState'].setValue('');
        this.addressForm.controls['SelectedShippingState'].setValue('');
      } else {
        if(this.addressForm.controls['ShippingState'].value!=''){
        this.addressForm.controls['ShippingState'].setValue(this.BillingAddress.ShippingState);
        }
        this.addressForm.controls['SelectedShippingState'].setValue('');     
      }
      this.addressForm.controls['SelectedShippingState'].setValidators([]);
      this.addressForm.controls['ShippingState'].setValidators([]);
      this.ShowError = false;
    } else {
      this.IsShippingUSorCanada = false;
      this.SetShowOtherCountryError(false); //changed FAD-1124
      this.SetShowError(false);
    }
    if (this.ShowOtherCountryShippingStateText === true) {
      this.addressForm.controls['ShippingZipCode'].setValidators([]);
    } else {
      if (countryInput === appVariables.CountryCode.Canada) {
        this.addressForm.controls['ShippingZipCode'].setValidators([Validators.maxLength(7), Validators.minLength(7),
        Validators.pattern(appVariables.Regex_ZipCodePattern_For_Canada)]);
      } else if (countryInput === appVariables.CountryCode.US) {
        this.addressForm.controls['ShippingZipCode'].setValidators([Validators.maxLength(5), Validators.minLength(5),
        Validators.pattern(appVariables.Regex_ZipPattern)]);
      } else { // if (countryInput === appVariables.CountryCode.US)
        this.addressForm.controls['ShippingZipCode'].setValidators([]);
      }
    }
    if (this.addressForm.controls['SelectedShippingState']) {
      this.addressForm.controls['SelectedShippingState'].updateValueAndValidity();
    }

    if (this.addressForm.controls['ShippingState']) {
      this.addressForm.controls['ShippingState'].updateValueAndValidity();
    }

    if (this.addressForm.controls['ShippingZipCode']) {
      this.addressForm.controls['ShippingZipCode'].updateValueAndValidity();
    }
    //  this.addressForm.controls['SelectedState'].setValue(this.ShippingStateList[3].Value);
    // (<FormControl>this.addressForm.controls['SelectedState'])
    // .setValue(this.ShippingStateList[3], { onlySelf: true });
    // this.addressForm.controls['SelectedState'].setValue(this.ShippingStateList[3], {onlySelf: true} );
    // this.addressForm.controls['SelectedState'].updateValueAndValidity();
    // tslint:disable-next-line:max-line-length
    // if (!this.addressForm.controls['SelectedShippingState'].value && this.addressForm.controls['BillingShippingDifferent'].value === true) {
    //   // this.BillingAddress.ShippingState = appVariables.DefaultState.ALBERTA;
    //    if (countryInput === appVariables.CountryCode.Canada) {
    //     this.addressForm.controls['SelectedShippingState'].setValue( this.BillingAddress.BillingCanadaStateList_ForAPI
    //        .find(country => country.Value &&
    //          country.Value.toUpperCase() === appVariables.DefaultState.ALBERTA.toUpperCase()));
    //    } else if (countryInput === appVariables.CountryCode.US) {
    //     this.addressForm.controls['SelectedShippingState'].setValue(this.BillingAddress.BillingUSAStateList_ForAPI
    //        .find(country => country.Value &&
    //          country.Value.toUpperCase() === appVariables.DefaultState.ALABAMA.toUpperCase()));
    //    }
    //  }
  }
  OnChangeValue(Checkevent) {
    if (Checkevent) {
      this.addressForm.controls['State'].setValue('');
      this.ContryChange(Checkevent, this.addressForm.controls['BillingShippingDifferent'].value);
    }
    this.OnValidateFormsModel(Checkevent);
  }
  OnShippingCOuntryChange(Checkevent) {
    if (Checkevent) {
      this.addressForm.controls['ShippingState'].setValue('');
      this.ShippingContryChange(Checkevent);
    }
    this.OnValidateFormsModel(Checkevent);
  }

  private initForm() {

    if (this.BillingAddress.BillingCountryCode === null) {
      this.BillingAddress.BillingCountryCode = appVariables.CountryCode.US;
      if (this.BillingAddress.State === null) {
        this.BillingAddress.State = '';
      }
    }
    // if (this.BillingAddress.Country) {
    //   this.BillingAddress.SelectedCountry = this.BillingAddress.BillingCountryList_ForAPI
    //     .find(country => country.Value && this.BillingAddress.Country &&
    //       country.Value.toUpperCase() === this.BillingAddress.Country.toUpperCase());
    //   if (this.BillingAddress.Country === appVariables.CountryCode.Canada) {
    //     this.BillingAddress.SelectedState = this.BillingAddress.BillingCanadaStateList_ForAPI
    //       .find(country => country.Value && this.BillingAddress.State &&
    //         country.Value.toUpperCase() === this.BillingAddress.State.toUpperCase());
    //   } else if (this.BillingAddress.Country === appVariables.CountryCode.US) {
    //     if (!this.BillingAddress.State) {
    //       this.BillingAddress.State = appVariables.DefaultState.ALABAMA;
    //     }
    //     this.BillingAddress.SelectedState = this.BillingAddress.BillingUSAStateList_ForAPI
    //       .find(country => country.Value && this.BillingAddress.State &&
    //         country.Value.toUpperCase() === this.BillingAddress.State.toUpperCase());
    //   } else {
    //     this.BillingAddress.State = this.BillingAddress.State.toUpperCase();
    //   }
    // }
    // if (this.BillingAddress.ShippingCountry) {
    //   // tslint:disable-next-line:max-line-length
    //   this.BillingAddress.SelectedShippingCountry = this.BillingAddress.BillingCountryList_ForAPI
    //     .find(country => country.Value && country.Value.toUpperCase() === this.BillingAddress.ShippingCountry.toUpperCase());
    //   if (this.BillingAddress.ShippingCountry === appVariables.CountryCode.Canada) {
    //     // tslint:disable-next-line:max-line-length
    //     this.BillingAddress.SelectedShippingState = this.BillingAddress.ShippingCanadaStateList_ForAPI
    //       .find(country => country.Value && this.BillingAddress.ShippingState &&
    //         country.Value.toUpperCase() === this.BillingAddress.ShippingState.toUpperCase());
    //   } else if (this.BillingAddress.ShippingCountry === appVariables.CountryCode.US) {
    //     // tslint:disable-next-line:max-line-length
    //     this.BillingAddress.SelectedShippingState = this.BillingAddress.ShippingUSAStateList_ForAPI
    //       .find(country => country.Value && this.BillingAddress.ShippingState &&
    //         country.Value.toUpperCase() === this.BillingAddress.ShippingState.toUpperCase());
    //   } else {
    //     this.BillingAddress.ShippingState = this.BillingAddress.ShippingState.toUpperCase();
    //   }
    // }

    this.addressForm = new FormGroup({
      'FirstName': new FormControl(this.BillingAddress.FirstName),
      'LastName': new FormControl(this.BillingAddress.LastName),
      'SelectedCountry': new FormControl(this.BillingAddress.BillingCountryCode),
      'StreetAddress': new FormControl(this.BillingAddress.StreetAddress),
      'AdditionalAddress': new FormControl(this.BillingAddress.AdditionalAddress),
      'City': new FormControl(this.BillingAddress.City),
      'SelectedState': new FormControl(this.BillingAddress.State),
      'State': new FormControl(this.BillingAddress.State),
      // 'ZipCode': new FormControl(this.BillingAddress.ZipCode, [Validators.required, Validators.maxLength(5), Validators.minLength(5),
      // Validators.pattern(this.zipcodePattern)]),
      'ZipCode': new FormControl(this.BillingAddress.ZipCode),
      'Phone': new FormControl(this.BillingAddress.Phone, [Validators.pattern(appVariables.RegexPhonePattern)]),
      'Ext': new FormControl(this.BillingAddress.Ext),
      'BillingShippingDifferent': new FormControl(this.BillingAddress.BillingShippingDifferent),
      'ShippingFirstName': new FormControl(this.BillingAddress.ShippingFirstName),
      'ShippingLastName': new FormControl(this.BillingAddress.ShippingLastName),
      'SelectedShippingCountry': new FormControl(this.BillingAddress.ShippingCountryCode),
      'ShippingStreetAddress': new FormControl(this.BillingAddress.ShippingStreetAddress),
      'ShippingAdditionalAddress': new FormControl(this.BillingAddress.ShippingAdditionalAddress),
      'ShippingCity': new FormControl(this.BillingAddress.ShippingCity),
      'ShippingState': new FormControl(this.BillingAddress.ShippingState),
      'SelectedShippingState': new FormControl(this.BillingAddress.ShippingState),
      'ShippingZipCode': new FormControl(this.BillingAddress.ShippingZipCode),
      'ShippingPhone': new FormControl(this.BillingAddress.ShippingPhone),
      'ShippingExt': new FormControl(this.BillingAddress.ShippingExt)
    });
    // if (this.ShowOtherCountryStateText === true) {
    //   this.addressForm.controls['ZipCode'].setValidators([Validators.required]);
    // } else {
    //   if (this.BillingAddress.Country === appVariables.CountryCode.Canada) {
    //     this.addressForm.controls['ZipCode'].setValidators([Validators.required,  Validators.maxLength(7), // Validators.minLength(6),
    //     Validators.pattern(appVariables.Regex_ZipCodePattern_For_Canada)]);
    //   } else if (this.BillingAddress.Country === appVariables.CountryCode.US) {
    //     this.addressForm.controls['ZipCode'].setValidators([Validators.required, Validators.maxLength(5), Validators.minLength(5),
    //     Validators.pattern(appVariables.Regex_ZipPattern)]);
    //   } else if (this.BillingAddress.Country === appVariables.CountryCode.US) {
    //     this.addressForm.controls['ZipCode'].setValidators([Validators.required]);
    //   }
    // }
    this.OnCheckClick(this.BillingAddress.BillingShippingDifferent);
    this.ContryChange(this.BillingAddress.BillingCountryCode, this.BillingAddress.BillingShippingDifferent);
    if (this.BillingAddress.ShippingCountryCode) {
      this.ShippingContryChange(this.BillingAddress.ShippingCountryCode);
    }

  }

  OnValidateFormsModel(data) {
    if (!this.IsUSorCanada && !this.IsShippingUSorCanada) {
      this.ShowError = false;
      return;
    }
    const containsInvalidFormat = this.InvalidAddressArray.some(format => data.toLowerCase().includes(format));
    this.ShowError = containsInvalidFormat || (data.length === 0) ? this.ShowError = true : ((this.ValiadteOtherFields(false) === true) ? this.ShowError = true : this.ShowError = false);
    //this.ShowError = (data.length === 0) ? this.ShowError = true : ((this.ValiadteOtherFields(false) === true) ? this.ShowError = true : this.ShowError = false);
  }

  ValiadteOtherFields(IsBSDiff) {
    this.IsBSDiff = IsBSDiff;
    const isUSOrCanada = this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.US || 
                       this.addressForm.controls['SelectedCountry'].value === appVariables.CountryCode.Canada;
    const isUSOrCanadaForShipping = this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.US || 
                       this.addressForm.controls['SelectedShippingCountry'].value === appVariables.CountryCode.Canada;
    if (this.addressForm.controls['BillingShippingDifferent'].value == false && IsBSDiff === false) {
      // if (IsBSDiff === false) {
      if (
        this.addressForm.controls['FirstName'].value === null || this.addressForm.controls['FirstName'].value === "" ||
        this.addressForm.controls['LastName'].value === null || this.addressForm.controls['LastName'].value === "" ||
        this.addressForm.controls['SelectedCountry'].value === null || this.addressForm.controls['SelectedCountry'].value === "" ||
        this.addressForm.controls['StreetAddress'].value === null || this.addressForm.controls['StreetAddress'].value === "" ||
        this.addressForm.controls['City'].value === null || this.addressForm.controls['City'].value === "" ||
        (isUSOrCanada 
          ? this.addressForm.controls['SelectedState'].value === null || this.addressForm.controls['SelectedState'].value === "" 
          : this.addressForm.controls['State'].value === null || this.addressForm.controls['State'].value === "") ||
        this.addressForm.controls['ZipCode'].value === null || this.addressForm.controls['ZipCode'].value === "" ||
        this.addressForm.controls['Phone'].value === null || this.addressForm.controls['Phone'].value === ""

      ) {
        this.ShowError = true;
      }
      else {
        this.ShowError = false;
      }
    }
    else {
      if (
        this.addressForm.controls['FirstName'].value === null || this.addressForm.controls['FirstName'].value === "" ||
        this.addressForm.controls['LastName'].value === null || this.addressForm.controls['LastName'].value === "" ||
        this.addressForm.controls['SelectedCountry'].value === null || this.addressForm.controls['SelectedCountry'].value === "" ||
        this.addressForm.controls['StreetAddress'].value === null || this.addressForm.controls['StreetAddress'].value === "" ||
        this.addressForm.controls['City'].value === null || this.addressForm.controls['City'].value === "" ||
        (isUSOrCanada 
          ? this.addressForm.controls['SelectedState'].value === null || this.addressForm.controls['SelectedState'].value === "" 
          : this.addressForm.controls['State'].value === null || this.addressForm.controls['State'].value === "") ||
        this.addressForm.controls['ZipCode'].value === null || this.addressForm.controls['ZipCode'].value === "" ||
        this.addressForm.controls['Phone'].value === null || this.addressForm.controls['Phone'].value === "" ||

        this.addressForm.controls['ShippingFirstName'].value === null || this.addressForm.controls['ShippingFirstName'].value === "" ||
        this.addressForm.controls['ShippingLastName'].value === null || this.addressForm.controls['ShippingLastName'].value === "" ||
        this.addressForm.controls['SelectedShippingCountry'].value === null || this.addressForm.controls['SelectedShippingCountry'].value === "" ||
        this.addressForm.controls['ShippingStreetAddress'].value === null || this.addressForm.controls['ShippingStreetAddress'].value === "" ||
        this.addressForm.controls['ShippingCity'].value === null || this.addressForm.controls['ShippingCity'].value === "" ||
        (isUSOrCanadaForShipping 
          ? this.addressForm.controls['SelectedShippingState'].value === null || this.addressForm.controls['SelectedShippingState'].value === "" 
          : this.addressForm.controls['ShippingState'].value === null || this.addressForm.controls['ShippingState'].value === "") ||
        this.addressForm.controls['ShippingZipCode'].value === null || this.addressForm.controls['ShippingZipCode'].value === "" ||
        this.addressForm.controls['ShippingPhone'].value === null || this.addressForm.controls['ShippingPhone'].value === ""

      ) {
        this.ShowError = true;
      }
      else {
        this.ShowError = false;
      }

    }

    return this.ShowError;
  }

  setUspsFormatedAddress(uspsAddressData: UspsAddressModel) {
    if (this.addressForm.controls.BillingShippingDifferent.value) {
      this.addressForm.controls['ShippingStreetAddress'].setValue(uspsAddressData.Address1);
      this.addressForm.controls['ShippingAdditionalAddress'].setValue(uspsAddressData.Address2);
      this.addressForm.controls['ShippingCity'].setValue(uspsAddressData.City);
      this.addressForm.controls['SelectedShippingState'].setValue(uspsAddressData.State);
      this.addressForm.controls['ShippingZipCode'].setValue(uspsAddressData.Zip5);
    } else {
      this.addressForm.controls['StreetAddress'].setValue(uspsAddressData.Address1);
      this.addressForm.controls['AdditionalAddress'].setValue(uspsAddressData.Address2);
      this.addressForm.controls['City'].setValue(uspsAddressData.City);
      this.addressForm.controls['SelectedState'].setValue(uspsAddressData.State);
      this.addressForm.controls['ZipCode'].setValue(uspsAddressData.Zip5);
    }
  }

  IsJsonEqual(addressForm: any, uspsFormatAddress: any) {
    this.addressObject = new UspsAddressModel();
    this.addressUspsObject = new UspsAddressModel();
    if (addressForm.BillingShippingDifferent) {
      this.addressObject.Address1 = addressForm.ShippingStreetAddress;
      this.addressObject.Address2 = addressForm.ShippingAdditionalAddress;
      this.addressObject.City = addressForm.ShippingCity;
      this.addressObject.State = addressForm.SelectedShippingState;
      this.addressObject.Zip5 = addressForm.ShippingZipCode;
    } else {
      this.addressObject.Address1 = addressForm.StreetAddress;
      this.addressObject.Address2 = addressForm.AdditionalAddress;
      this.addressObject.City = addressForm.City;
      this.addressObject.State = addressForm.SelectedState;
      this.addressObject.Zip5 = addressForm.ZipCode;
    }
    if (uspsFormatAddress[0].Address1 === undefined && uspsFormatAddress[0].Address2 !== undefined) {
      this.addressUspsObject.Address1 = uspsFormatAddress[0].Address2[0];
    } else {
      this.addressUspsObject.Address1 = uspsFormatAddress[0].Address1 === undefined ? '' : uspsFormatAddress[0].Address1[0];
    }
    if (uspsFormatAddress[0].Address1 === undefined && uspsFormatAddress[0].Address2 !== undefined) {
      this.addressUspsObject.Address2 = '';
    } else {
      this.addressUspsObject.Address2 = uspsFormatAddress[0].Address2 === undefined ? '' : uspsFormatAddress[0].Address2[0];
    }
    // this.addressUspsObject.Address1 = uspsFormatAddress[0].Address1 === undefined ? '' : uspsFormatAddress[0].Address1[0];
    // this.addressUspsObject.Address2 = uspsFormatAddress[0].Address2 === undefined ? '' : uspsFormatAddress[0].Address2[0];
    this.addressUspsObject.City = uspsFormatAddress[0].City === undefined ? '' : uspsFormatAddress[0].City[0];
    this.addressUspsObject.State = uspsFormatAddress[0].State === undefined ? '' : uspsFormatAddress[0].State[0];
    this.addressUspsObject.Zip5 = uspsFormatAddress[0].Zip5 === undefined ? '' : uspsFormatAddress[0].Zip5[0];
    if (JSON.stringify(this.addressObject) === JSON.stringify(this.addressUspsObject)) {
      return true;
    }

    return false;
  }

  CheckHyphenValidation(inputAddress: string, addressFieldType: string): void {
    if (inputAddress) {
      if (inputAddress.indexOf('-') > -1) {
        if (addressFieldType == 'shippingAddress') {
          this.chkBillingPOBoxAddress = '';
          this.StreetNumApiErrorMsg = this.hyphenValidationErrorMessage;
        }
        else if (addressFieldType == 'additionalAddress') {
          this.chkBillingPOBoxAditionalAddress = this.hyphenValidationErrorMessage;
        }
        else if (addressFieldType == 'ShippingStreetAddress') {
          this.chkShippingPOBoxAddress = this.hyphenValidationErrorMessage;
        }
        else if (addressFieldType == 'ShippingAdditionalAddress') {
          this.chkShippingPOBoxAditionalAddress = this.hyphenValidationErrorMessage;
        }
      }
      else {
        if (addressFieldType == 'additionalAddress') {
          this.chkBillingPOBoxAditionalAddress = '';
        }
        else if (addressFieldType == 'ShippingStreetAddress') {
          this.chkShippingPOBoxAddress = '';
        }
        else if (addressFieldType == 'ShippingAdditionalAddress') {
          this.chkShippingPOBoxAditionalAddress = '';
        }
        this.chkPOAddressFormat = this.ValidatePOBox(addressFieldType);
      }

    }
    else {
      this.chkPOAddressFormat = this.ValidatePOBox(addressFieldType);
    }
  }

  ValidationCheckforShippingAddress(isShipping: boolean = false): void {
    if (!this.IsUSorCanada && !this.IsShippingUSorCanada) {
      this.ValidShippingZipCodeLength = false;
      this.ShowError = false;
      return;
    }
    let validCheck: boolean;
    if (!isShipping) {
      validCheck = !this.StreetNumApiErrorMsg && !this.chkBillingPOBoxAddress && !this.chkBillingPOBoxAditionalAddress
        && !this.ValidZipCodeLength && !this.ZipCodeApiErrorMsg && !this.PhoneNumApiErrorMsg;
      this.ShowError = !validCheck;
    }
    else {
      validCheck = !this.chkShippingPOBoxAddress && !this.chkShippingPOBoxAditionalAddress
        && !this.ValidShippingZipCodeLength && !this.ShippingZipApiErrorMsg && !this.ShippingPhoneApiErrorMsg;
      this.ShowError = !validCheck;
    }
  }

  containsPOBox(address: string): boolean {
    return this.InvalidAddressArray.some(x=> address.toLowerCase().indexOf(x)>=0);
  }

  isPaymentDisabled(): boolean {
    if (this.addressForm && this.addressForm.controls['BillingShippingDifferent']) {
      const isBillingShippingDifferent = this.addressForm.controls['BillingShippingDifferent'].value;
      if (isBillingShippingDifferent) {
        return false;
      }
    }
    const streetAddress = document.getElementById('shippingAddress') as HTMLInputElement;
    if (this.containsPOBox(streetAddress.value)) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/address/address.component.ts